import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import ListingFormDetails from './forms/listingFormDetails';
import ListingFormDescriptions from './forms/listingFormDescriptions';
import ListingFormAmenities from './forms/listingFormAmenities';
import ListingFormPhotos from './forms/listingFormPhotos';
import ListingFormPhotosOrder from './forms/listingFormPhotosOrder';
import ListingFormPricing from './forms/listingFormPricing';
import ListingFormAddOns from './forms/listingFormAddOns';
import ListingFormCalendars from './forms/listingFormCalendars';
import ListingFormManageAvailability from './forms/listingFormManageAvailability';
import ListingFormPreview from './forms/listingFormPreview';

import { ListingFormSteps } from './constants';

const stepComponents = [
  { step: 1, component: <ListingFormDetails workflow="forms" parent="dashboard" step={1} /> },
  { step: 2, component: <ListingFormDescriptions workflow="forms" parent="dashboard" step={2} /> },
  { step: 3, component: <ListingFormAmenities workflow="forms" parent="dashboard" step={3} /> },
  { step: 4, component: <ListingFormPhotos workflow="forms" parent="dashboard" step={4} /> },
  { step: 5, component: <ListingFormPhotosOrder workflow="forms" parent="dashboard" step={5} /> },
  { step: 6, component: <ListingFormPricing workflow="forms" parent="dashboard" step={6} /> },
  { step: 7, component: <ListingFormAddOns workflow="forms" parent="dashboard" step={7} /> },
  { step: 8, component: <ListingFormCalendars workflow="forms" parent="dashboard" step={8} /> },
  { step: 9, component: <ListingFormManageAvailability workflow="forms" parent="dashboard" step={9} /> },
  { step: 10, component: <ListingFormPreview workflow="forms" parent="dashboard" step={10} /> }
]

class CreateListingComponent extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="container listing-container" id="new-listing-container">
        <h2>Create New Listing</h2>
        {ListingFormSteps.map(lfs => <Route key={`create-listing-${lfs.step}`} path={`/dashboard/listing/forms/${lfs.name}`}
          render={() => { return stepComponents.find(sc => sc.step === lfs.step).component }} />)}
      </div>
    );
  }

}

export default CreateListingComponent;
